export default "__VITE_ASSET__CbJUNdEU__"